import React from 'react';
import '../styles/JoinAssociation.css';

const membershipSteps = [
  {
    id: '01',
    title: '1 ступень. Кандидат в члены АПП',
    items: [
      'Наличие незаконченного или законченного психологического образования.',
      'Участие в семинарах и образовательных встречах в Ассоциации — не менее 50% посещённых встреч.',
      'Испытательный срок — 6 месяцев.',
      'Оплата членских взносов ежемесячно в размере 1000 рублей на протяжении всего испытательного срока.',
    ],
  },
  {
    id: '02',
    title: '2 ступень. Наблюдательный член АПП',
    items: [
      'Наличие незаконченного или законченного психологического образования.',
      'Посещение мероприятий АПП в течение полугода.',
      'Прохождение процедуры приёма через собеседование с тренинг-комитетом.',
      'Необходимо подать заявление и предоставить перечень документов, который выдаст тренинг-комитет.',
      'Оплата членских взносов ежемесячно в размере 2000 рублей.',
    ],
  },
  {
    id: '03',
    title: '3 ступень. Ассоциативное членство АПП',
    items: [
      'Наличие высшего психологического образования или пройденной процедуры повышения квалификации.',
      'Участие в семинарах Ассоциации — не менее 50% посещённых встреч в месяц.',
      'Наличие личной терапии.',
      'Наличие супервизии.',
      'Наличие практики не менее 3 часов в неделю.',
      'Успешное прохождение процедуры приёма. Тренинг-комитету необходимо представить случай на супервизию.',
      'Оплата членских взносов ежемесячно в размере 2000 рублей.',
    ],
  },
  {
    id: '04',
    title: '4 ступень. Действительное членство АПП',
    items: [
      'Наличие психологического образования или пройденной процедуры повышения квалификации.',
      'Наличие постоянной практики в течение 2 лет.',
      'Наличие индивидуальных супервизий.',
      'Оплата членских взносов ежемесячно в размере 2000 рублей.',
    ],
  },
];

function JoinAssociation() {
  return (
    <main className="join-page">

      {/* ШАПКА */}
      <section className="join-intro">
        <div className="app-container">
          <div className="join-intro__simple">
            <h1>
              Вступление в Ассоциацию Практикующих Психологов
            </h1>

            <p>
              Ассоциация Практикующих Психологов (АПП) — это профессиональное
              сообщество, объединяющее специалистов, стремящихся к высоким
              стандартам в области психологии. Ниже представлены ступени
              членства и критерии для вступления.
            </p>
          </div>
        </div>
      </section>

      {/* ЗАЯВКА */}
      <section className="join-application">
        <div className="app-container">
          <div className="join-application__box">

            <h2>Подать заявку на вступление</h2>

            <p>
              Заполните короткую форму — и мы свяжемся с вами
              для обсуждения дальнейших шагов.
            </p>

            <a
              href="https://www.buildin.ai/form/2ace78f6-d9c0-489a-ad37-eb801ce3772c?code=GC2JSA"
              target="_blank"
              rel="noopener noreferrer"
              className="join-application__button"
            >
              Вступить в АПП
            </a>

          </div>
        </div>
      </section>

      {/* СТУПЕНИ ЧЛЕНСТВА */}
      <section className="join-membership">
        <div className="app-container">

          <div className="join-membership__heading">
            <h2>Ступени членства в АПП</h2>
          </div>

          <div className="join-membership__list">
            {membershipSteps.map((step) => (
              <article
                className="join-membership-card"
                key={step.id}
              >
                <div className="join-membership-card__header">
                  <span className="join-membership-card__number">
                    {step.id}
                  </span>

                  <h3>{step.title}</h3>
                </div>

                <ul>
                  {step.items.map((item) => (
                    <li key={item}>
                      {item}
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

        </div>
      </section>

      {/* НА ГЛАВНУЮ */}
      <section className="join-home">
        <div className="app-container">
          <div className="join-home__inner">

            <a
              href="/"
              className="join-home__button"
            >
              На главную
            </a>

          </div>
        </div>
      </section>

    </main>
  );
}

export default JoinAssociation;